// extracted by mini-css-extract-plugin
export var buttonRow = "NotificationEmailPrompt-module__buttonRow___v6bL6";
export var currentEmail = "NotificationEmailPrompt-module__currentEmail___VoV+E";
export var emailInput = "NotificationEmailPrompt-module__emailInput___S2-Wy";
export var errorMessage = "NotificationEmailPrompt-module__errorMessage___zmfVT";
export var primaryButton = "NotificationEmailPrompt-module__primaryButton___aEq1l";
export var promptContainer = "NotificationEmailPrompt-module__promptContainer___XebdI";
export var promptDescription = "NotificationEmailPrompt-module__promptDescription___t3+D3";
export var promptTitle = "NotificationEmailPrompt-module__promptTitle___oBb7L";
export var secondaryButton = "NotificationEmailPrompt-module__secondaryButton___G1MJ+";